<template>
<div>
    SAMPLE WIDGET {{label}}
</div>
</template>

<script>
import labels from './LanguageLabels.js'

export default {
    data: function(){
        return {
            label: labels,
        }
    },

}
</script>

<style>

</style>